import i18n from "../../helpers/lang/i18n"

export const getFieldsAgents = () => {
  const t = i18n.global.t
  return [
    {
      key: 'id',
      label: t('ajustes.agentes.id_agente'),
      sortable: true,
    },
    {
      key: 'name',
      label: t('global.nombre'),
      sortable: true,
    },
    {
      key: 'email',
      label: t('global.email'),
      sortable: true,
    },
    {
      key: 'rfc',
      label: t('global.rfc'),
    },
    {
      key: 'edit',
      label: t('global.editar'),
      thClass: 'text-center'
    },
    {
      key: 'delete',
      label: t('global.eliminar'),
      thClass: 'text-center'
    }
  ]
}
